<template lang="pug">
.send-message-select-modal
  b-modal(ref="modal" size="xl" no-close-on-backdrop no-close-on-esc @ok="add" @cancel="cancel")
    template(v-slot:modal-title)
      span {{ title }}
      span.font-strong-color {{ titleMessage }}

    b-card-group.send-message-select-modal-card-group(deck)
      b-card.align-self-start(no-body)
        .send-message-header(slot="header")
          div.mb-1 利用者グループ
          .search-filter.d-flex.flex-row.justify-content-end.align-items-center
            b-input-group.search-filter-input-group.mr-1(size="md")
              b-input-group-prepend
                b-input-group-text.search-filter-icon
                  .search-icon
              b-form-input.search-filter-input(v-model="residentGroupSearchWord" type="search" placeholder="利用者グループの検索"
                @input="inputResidentGroupSearchWord")
            HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="resident-group-search-filter-help" title="検索項目について")
              template(v-slot:text)
                div 検索項目は以下になります。
                div ・利用者グループ
        b-list-group.select-area(flush)
          b-list-group-item(@click="selectAllGroup" href="#" :class="_allGroupSelectedClass") 全て
          template(v-for="group in targets")
            b-list-group-item(v-if="group.show" href="#" @click="selectGroup(group)" :class="getGroupSelectedClass(group.id)") {{ group.name }}

      b-card.align-self-start(no-body)
        .send-message-header(slot="header")
          div.mb-1 {{ groupName }}
          .search-filter.d-flex.flex-row.justify-content-end.align-items-center(v-if="selectedGroupId != 0")
            b-input-group.search-filter-input-group.mr-1(size="md")
              b-input-group-prepend
                b-input-group-text.search-filter-icon
                  .search-icon
              b-form-input.search-filter-input(v-model="residentSearchWord" type="search"
                placeholder="利用者の検索" @input="inputResidentSearchWord")
            HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="resident-search-filter-help" title="検索項目について")
              template(v-slot:text)
                div 検索項目は以下になります。
                div ・利用者名
                div ・部屋名
        b-list-group.select-area(flush)
          template(v-for="resident in viewResidents")
            b-list-group-item(v-if="resident.show" href="#" @click="selectResident(resident)"
              :class="getResidentSelectedClass(resident.id)") {{ resident.name }}（{{resident.room}}）

      b-card.align-self-start(no-body)
        .send-message-header(slot="header")
          div.mb-1 {{ residentName }}
          .search-filter.d-flex.flex-row.justify-content-end.align-items-center(v-if="selectedResidentId != 0")
            b-input-group.search-filter-input-group.mr-1(size="md")
              b-input-group-prepend
                b-input-group-text.search-filter-icon
                  .search-icon
              b-form-input.search-filter-input(v-model="familySearchWord" type="search"
                placeholder="家族の検索" @input="inputFamilySearchWord")
            HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="family-search-filter-help" title="検索項目について")
              template(v-slot:text)
                div 検索項目は以下になります。
                div ・家族名
        b-list-group.family-area(flush)
          b-list-group-item(v-if="0 < viewFamily.length")
            b-form-checkbox(v-model="allFamily" @change="selectAllFamily" :disabled="_disableAllFamily")
              span 全員
          b-list-group-item(v-if="family.show" v-for="family in viewFamily" :key="family.residentsSortKey")
            b-form-checkbox(v-model="family.isTarget")
              span {{ family.familyName }}{{ getSenderType(family.senderType) }}（{{ getRelation(family) }}）

    div(slot="modal-footer" slot-scope="{ ok, cancel }")
      button.btn.modal-ok-btn(v-if="_checked" type="button" @click="ok()") OK
      button.btn.modal-ok-btn.disable(v-else type="button" disabled) OK
      button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { SendMessageTargetGroup, SendMessageTargetResident, SendTargetFamily } from "@/commons/models/SendMessageTarget";
import { SenderType } from "@/commons/models/Resident";
import HelpIcon from "@/pc/basics/HelpIcon.vue";

/**
 * メッセージ送信宛先選択モーダル
 */
@Component({
  components: {
    HelpIcon
  }
})
export default class SendMessageSelectModal extends Vue {
  /** ダイアログタイトル */
  @Prop({ default: "宛先を選択してください。" })
  title!: string;
  /** タイトルメッセージ */
  @Prop({ default: undefined })
  titleMessage!: string;

  /** 利用者グループ検索ワード */
  residentGroupSearchWord: string = "";
  /** 利用者名検索ワード */
  residentSearchWord: string = "";
  /** 家族名検索ワード */
  familySearchWord: string = "";

  /** 宛先対象リスト */
  targets: Array<SendMessageTargetGroup> = [];
  /** 選択されている利用者グループID */
  selectedGroupId: number = 0;
  /** 利用者グループ名 */
  groupName: string = "　";
  /** 選択されている利用者ID */
  selectedResidentId: number = 0;
  /** 選択された宛先候補の利用者名 */
  residentName: string = "　";
  /** 宛先候補の利用者 */
  viewResidents: Array<SendMessageTargetResident> = [];
  /** 宛先候補の家族 */
  viewFamily: Array<SendTargetFamily> = [];
  /** 家族全員が選択されてか否か */
  allFamily: boolean = false;

  get _checked(): boolean {
    let checked: boolean = false;

    for (const target of this.targets) {
      for (const resident of target.residents) {
        for (const family of resident.families) {
          if (family.isTarget == true) {
            checked = true;
            break;
          }
        }
      }
    }

    return checked;
  }

  get _disableAllFamily(): boolean {
    if (this.familySearchWord != "") {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ### 送信種別に応じてサフィックスを返す
   */
  public getSenderType(senderType: SenderType): string {
    if (senderType == SenderType.MAIL) {
      return "（メール）";
    } else {
      return "";
    }
  }

  public getRelation(family: SendTargetFamily): string {
    const relation: string = family.familyRelation;
    const position: string = family.familyPosition ? `・${family.familyPosition}` : "";

    return `${relation}${position}`;
  }

  get _allGroupSelectedClass(): any {
    return {
      "selected-resident-group": this.selectedGroupId === -1 ? true : false
    };
  }

  public getGroupSelectedClass(id: number): any {
    return {
      "selected-resident-group": this.selectedGroupId === id ? true : false
    };
  }

  public getResidentSelectedClass(id: number): any {
    return {
      "selected-resident": this.selectedResidentId === id ? true : false
    };
  }

  public inputResidentGroupSearchWord(): void {
    if (!this.residentGroupSearchWord) {
      for (const target of this.targets) {
        target.show = true;
      }
      return;
    }

    const words: string[] = this.$filterUtil.createSearchWord(this.residentGroupSearchWord);
    for (const target of this.targets) {
      target.show = false;
      for (const word of words) {
        if (-1 < target.name.indexOf(word)) {
          target.show = true;
          break;
        }
      }
      // 現在選択されている利用者グループが表示対象外の場合、利用者、家族の選択をリセットする
      if (target.id == this.selectedGroupId && target.show == false) {
        this.selectedGroupId = 0;
        this.viewResidents = [];
        this.groupName = "　";
        this.residentName = "　";
        this.viewFamily = [];
        this.allFamily = false;

        this.selectedResidentId = 0;
        this.residentName = "　";
        this.viewFamily = [];
        this.allFamily = false;
      }
    }
    return;
  }

  /**
   * ### 利用者グループの全て選択イベント
   */
  public selectAllGroup(): void {
    const viewResidents = [];
    for (const group of this.targets) {
      for (const resident of group.residents) {
        resident.show = true;
        viewResidents.push(resident);
      }
    }
    this.viewResidents = viewResidents;
    this.groupName = "全て";

    this.residentName = "　";
    this.viewFamily = [];
    this.allFamily = false;

    this.selectedGroupId = -1;

    return;
  }

  /**
   * ### 利用者グループ選択イベント処理
   */
  public selectGroup(group: SendMessageTargetGroup): void {
    if (this.selectedGroupId != group.id) {
      for (const resident of group.residents) {
        resident.show = true;
      }
      this.viewResidents = group.residents;
      this.groupName = group.name + "の利用者";

      this.residentName = "　";
      this.viewFamily = [];
      this.allFamily = false;
    }
    this.selectedGroupId = group.id;

    return;
  }

  public inputResidentSearchWord(): void {
    for (const resident of this.viewResidents) {
      if (!this.residentSearchWord) {
        resident.show = true;
        continue;
      }

      const words: string[] = this.$filterUtil.createSearchWord(this.residentSearchWord);
      resident.show = false;
      for (const word of words) {
        // 利用者名
        if (-1 < resident.name.indexOf(word)) {
          resident.show = true;
          break;
        }

        // ふりがな
        if (resident.kanaName) {
          if (-1 < resident.kanaName.indexOf(word)) {
            resident.show = true;
            break;
          }
        }

        // 部屋名
        if (-1 < resident.room.indexOf(word)) {
          resident.show = true;
          break;
        }
      }
      // 現在選択されている利用者が表示対象外の場合、家族の選択をリセットする
      if (resident.id == this.selectedResidentId && resident.show == false) {
        this.selectedResidentId = 0;

        this.residentName = "　";
        this.viewFamily = [];
        this.allFamily = false;
      }
    }
    return;
  }

  /**
   * ### 利用者選択イベント処理
   */
  public selectResident(resident: SendMessageTargetResident): void {
    this.residentName = `${resident.name}（${resident.room}）様のご家族`;
    for (const family of resident.families) {
      family.show = true;
    }
    this.viewFamily = resident.families;
    this.allFamily = this.isAllFamilyChecked();

    this.selectedResidentId = resident.id;

    return;
  }

  public inputFamilySearchWord(): void {
    for (const family of this.viewFamily) {
      if (!this.familySearchWord) {
        family.show = true;
        continue;
      }

      const words: string[] = this.$filterUtil.createSearchWord(this.familySearchWord);
      family.show = false;
      for (const word of words) {
        if (-1 < family.familyName.indexOf(word)) {
          family.show = true;
          break;
        }
      }
    }
    return;
  }

  /**
   * ### 家族宛先選択で「全員」選択イベント処理
   */
  public selectAllFamily(checked: boolean): void {
    for (let family of this.viewFamily) {
      family.isTarget = checked;
    }
    this.allFamily = checked;

    return;
  }

  /**
   * ### 家族宛先選択で全員がチェックされているかを調べる
   *
   * - 全家族を調べて、1人でもチェックされてないものがあればfalseを返す
   */
  public isAllFamilyChecked(): boolean {
    let checked: boolean = true;

    for (let family of this.viewFamily) {
      if (family.isTarget == false) {
        checked = false;
        break;
      }
    }

    return checked;
  }

  /**
   * ### モーダル表示
   *
   * - 利用者は未選択の状態で表示する
   */
  public show(targets: Array<SendMessageTargetGroup>): void {
    this.targets = targets;
    this.groupName = "　";
    this.viewResidents = [];
    this.residentName = "　";
    this.viewFamily = [];
    this.allFamily = false;
    this.selectedGroupId = 0;
    this.selectedResidentId = 0;

    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }

  /**
   * ### OKボタン押下イベント
   *
   * - 親コンポーネントに入力情報を通知する
   */
  public add(): void {
    this.$emit("add", this.targets);

    return;
  }

  /**
   * ### キャンセルボタン押下イベント
   *
   * - 入力した内容を全て破棄する
   * - 親コンポーネントに通知する
   */
  public cancel(): void {
    for (let group of this.targets) {
      for (let resident of group.residents) {
        for (let family of resident.families) {
          family.isTarget = false;
        }
      }
    }

    this.$emit("cancel");

    return;
  }
}
</script>

<style lang="scss">
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.font-strong-color {
  color: $font-strong-color;
}

.send-message-select-modal-card-group {
  .search-filter {
    .search-filter-input-group {
      .search-filter-icon {
        background-color: #fff !important;
      }
      .search-filter-input {
        border-left: 0;
      }
    }
  }

  .select-area {
    position: relative;
    max-height: calc(100vh - 300px);
    overflow-y: auto;
  }
  .family-area {
    position: relative;
    max-height: calc(100vh - 300px);
    overflow-y: auto;
  }

  .selected-resident-group,
  .selected-resident {
    background-color: $btn-selected !important;
    color: $btn-font-selected !important;
  }

  .send-message-header {
    @include bold-font(16px);
  }
  .list-group-item.resident.list-group-item-action {
    &:hover {
      background-color: $list-hover;
    }
    &:focus {
      background-color: $list-selected;
    }
  }
}
</style>
